import { useConfig } from "@stadium/hooks/lib/use-config";

import { getLockerShopFeUrl } from "@selectors/config";

import { SHOP_CATALOG_PATH_SUFFIX } from "@stadium/constants/routes";

const useLockerUrlConfig = () => {
  const lockerFeUrl = useConfig(getLockerShopFeUrl);

  const lockerCatalogUrl = lockerFeUrl ? `${lockerFeUrl}${SHOP_CATALOG_PATH_SUFFIX}` : lockerFeUrl;

  return {
    lockerFeUrl,
    lockerCatalogUrl,
  };
};

export default useLockerUrlConfig;
